<template>
  <hr aria-hidden="true" />
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

hr {
  background-color: colors.$alpha-10;
  height: 1px;
}
</style>
